/* ============
 * Cart Store
 * ============
 */

import { defineStore } from 'pinia';
import './pinia';

export const useCartStore = defineStore('cart', {
  state: () => ({
    token: null,
    order: null,
    category: null,
    quote: null,
    selectedTemplate: null,
    from: null,
    stripeSession: null,
  }),

  actions: {
    store(data) {
      this.order = data.order;
      this.category = data.category;
      this.quote = data.quote;
      if (data.token) {
        this.token = data.token;
        localStorage.setItem('checkout_cart_current_token', data.token);
      }
    },

    load() {
      this.token = localStorage.getItem('checkout_cart_current_token');
    },

    clear() {
      this.token = null;
      this.category = null;
      this.quote = null;
      this.from = null;
      this.selectedTemplate = null;
      this.stripeSession = null;
      localStorage.removeItem('checkout_cart_current_token');
    },

    selectTemplate(data) {
      this.selectedTemplate = data;
    },

    // Was `from` under Vuex. Pinia merges state, getters and actions into a
    // single namespace, so the action could not keep the name of the `from`
    // state key.
    setFrom(data) {
      this.from = data;
    },
  },
});

export default useCartStore;
